import { InfoIcon } from '@chakra-ui/icons'
import { As, HStack, LayoutProps, Text, VStack } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { IconPropsType } from 'components/SVGS'

interface CustomAlertProps {
  icon?: As<IconPropsType>
  description?: string
  iconSize?: LayoutProps['w']
  alertType?: 'danger' | 'info' | 'success' | 'warning'
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  description,
  icon:
  Icon,
  iconSize = 5,
  children,
  alertType = 'danger'
}) => {
  const { alerts: { danger, info, success, warning }, modal: { bgColorContent } } = themeColors

  return (
    <VStack bg={bgColorContent} rounded='lg' spacing={4} borderLeftWidth={6} borderLeftColor={danger}>
      {!children && description
        ? <HStack p={2} spacing={2}>
          {Icon
            ? <Icon size={iconSize} />
            : <InfoIcon width={iconSize} height={iconSize} color={
              alertType === 'danger'
                ? danger
                : alertType === 'warning'
                  ? warning
                  : alertType === 'success'
                    ? success : info
            } />}
          <Text variant='SM'>{description}</Text>
        </HStack>
        : <VStack p={4} spacing={4}>
          {children}
        </VStack>}
    </VStack>
  )
}

export default CustomAlert
